import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ResponseResumenIntentosModel } from 'src/app/model/Etapas.model';
import { apiService } from 'src/app/service/api.service';
import { ModalVideoComponent } from '../dialogs/modal-video/modal-video.component';
import { JardinModel, ResponseJardinModel } from 'src/app/model/Jardin.model';
import { environment } from 'src/environments/environment';
import { StorageService } from 'src/app/service/storage.service';

@Component({
  selector: 'app-capacitacion-jardin',
  templateUrl: './capacitacion-jardin.component.html',
  styleUrls: ['./capacitacion-jardin.component.css']
})
export class CapacitacionJardinComponent implements OnInit {

  @Input() simulacion: boolean;
  public isCollapsed1 = true;
  public isCollapsed2 = true;
  public isCollapsed3 = true;
  public isCollapsed4 = true;
  public isCollapsed5 = true;
  public isCollapsed6 = true;
  public cantidadIntentos = 3

  dataValid:any;

  status = "No iniciada";
  inProgress: boolean = false;
  finished: boolean = false;
  dataJardin = new JardinModel();
  comenzarValid:boolean = false;

  inicioCapacitacion: boolean = false;

  constructor(
    public dialog: MatDialog,
    private api: apiService,
    private storageService: StorageService
  ) { }

  ngOnInit(): void {
    this.inicioCapacitacion = false;
    this.getResumen();
    //this.dataJardin = this.api.dataJardin;
    this.cargaEstados();
    this.obtenerDataJardin();
  }


  
  obtenerDataJardin(){
    this.api.API_POST_obtenerJardin(this.storageService.getCurrentUser().idUsuario).subscribe((response:ResponseJardinModel) => {
      this.api.dataJardin = response.payload;
      this.dataJardin = response.payload;
    },
    (err) => { 
      console.log(err)
    })
  }
  
  cargaEstados() {
    this.inProgress = this.dataJardin.etapaJardin >= 1;
    this.finished = this.dataJardin.etapaJardin > 1;
    
    if (this.dataJardin.etapaJardin = 1) {
      this.status = "En progreso";
    }
    if (this.dataJardin.etapaJardin = 2) {
      this.status = "Finalizado";
    }
  }

  
  verVideo(nombre){
    switch(nombre){
      case 'intro1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/N6d2t5UVcZQ'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'intro2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/psG1mEM3jpY'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'intro3':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://view.genial.ly/612556b4b54a560d288d7b75',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      } 

      case 'intro4':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1/IGDE.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      } 

      case 'intro5':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1/MMGCEP.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      } 

      case 'intro6':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/whS0fucUI5A'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion1cap1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://view.genial.ly/611a6d338ad90d0d9f236f22',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      
      case 'sesion1cap2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/Dd59j3MNi6o'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion1cap3':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/tX6NyabhLCI'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion1ppt1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1/PptM1.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://view.genial.ly/614a4c64de5ed50d9f1349a4',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2ppt1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion1/PptM2.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: ''}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap3':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: ''}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap4':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion2/Orientaciones-para-Elaborar-el-Proyecto-Educativo-Institucional-en-eep.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap5':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion2/Anexo1PEIGC.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap6':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion2/Anexo2PEIGA.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      case 'sesion2cap7':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://wordwall.net/es/embed/3bbba0c378c74c989a39bfbf1bb57ebd?themeId=1&templateId=2',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion3cap1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion3/GE8.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
      
      case 'sesion3cap2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/7fjY5BL-uok',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion3cap3':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/FJFCyuliiWc',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion3cap4':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/9rZl_FspUHg',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      
      case 'sesion3cap5':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion3/ppt3.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion4doc1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion4/doc1.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion4cap1':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/ZLrIeWveOVE',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion4cap2':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/7XKkeRbiWdU',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }
            
      case 'sesion4cap3':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://www.youtube.com/embed/riOjGmbFUFg',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }

      case 'sesion4cap4':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'https://wordwall.net/es/embed/ddb0850d86574e509284b83cd2945366?themeId=1&templateId=35',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {

          });
        break;
      }


      case 'sesion4cap5':{
        const dialogRef = 
          this.dialog.open(ModalVideoComponent, {
            disableClose: true ,
            data: {url: 'assets/documentos/2021/sesion4/ppt4.pdf',size: 'xl'}
          });

          dialogRef.afterClosed().subscribe(result => {
 
          });
        break;
      }
      
      
    }
  }

  comenzar(){
    this.inicioCapacitacion = true;
  }

  getResumen(){
    this.api.API_POST_obtenerResumenIntentos().subscribe((response: ResponseResumenIntentosModel) => {
      const cuantoLlevo = response.payload.length;
      this.dataValid = response.payload

      this.cantidadIntentos =  this.cantidadIntentos  - cuantoLlevo;
        if(this.dataValid.length > 0){        
          this.dataValid.forEach(element => {

            if (element.porcentaje>=60){
              this.cantidadIntentos = 0;
              this.comenzarValid = true;
            }

            if(this.dataValid.length === 3){
              this.cantidadIntentos = 0;
              this.comenzarValid = true;
            }
            
          });
        }

    },
    (err) => {
      console.log(err)
    })     
  }


  descargarCertificado(){
  var pdfDocumentSrc = environment.apiEndpoint + "evaluacion/obtenerCertificado/" + this.storageService.getCurrentUser().idUsuario;
  const dialogRef = 
  this.dialog.open(ModalVideoComponent, {
    disableClose: true ,
    data: {url: pdfDocumentSrc ,size: 'xl'}
  });


  dialogRef.afterClosed().subscribe(result => {

  });
}

  

}
